import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DISHES_AVAILABLE_FOR_QC_COUNTS_QUERY } from '../graphql/queries'
import { FETCH_DISHES_AVAILABLE_FOR_QC_COUNTS } from '../redux/action-types'

const useDishesAvailableForQcCountsLazyQuery = ({
  wasDoneInPreviousTwoWeeks,
}) => {
  const dispatch = useDispatch()

  const {
    availableForQcCounts: data,
    isAvailableForQcCountsLoading: isLoading,
    availableForQcCountsError: error,
  } = useSelector(store => store.dishes.dishes)

  const fetch = useCallback(
    menuId =>
      apolloService.query({
        query: DISHES_AVAILABLE_FOR_QC_COUNTS_QUERY,
        variables: {
          menuId,
          filters: {
            wasDoneInPreviousTwoWeeks,
          },
        },
        dispatch,
        action: FETCH_DISHES_AVAILABLE_FOR_QC_COUNTS,
      }),
    [dispatch, wasDoneInPreviousTwoWeeks],
  )

  return [fetch, { isLoading, error, data }]
}

export default useDishesAvailableForQcCountsLazyQuery
